import { useTranslation } from 'react-i18next';
import NoticeComponent from '../../components/NoticeComponent';
import { Services_ARR } from '../../data';
import { useState } from 'react';
import { IoCloseOutline } from 'react-icons/io5';
import { useMediaQuery } from 'react-responsive';

export default function Cs() {
  const [activeSection, setActiveSection] = useState<string | null>(null);
  const { t } = useTranslation();
  const [openId, setOpenId] = useState<number | null>(null);

  const toggleAnswer = (id: number, section: string) => {
    if (openId === id) {
      setOpenId(null);
      setActiveSection(null);
    } else {
      setOpenId(id);
      setActiveSection(section);
    }
  };

  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <div>
      <div className="max-w-[1440px] h-full min-h-screen w-full mx-auto mobile:px-4 mobile:pb-[60px]">
        <div className="mt-[130px]">
          <NoticeComponent
            title={t('notice.toptitle')}
            content={
              isMobile ? (
                <>
                  고객님이 자주 궁금해하시는 내용을 모아두었습니다.
                  <br />
                  문제 해결에 도움이 되는 답변을 확인해보세요.
                </>
              ) : (
                '고객님이 자주 궁금해하시는 내용을 모아두었습니다. 문제 해결에 도움이 되는 답변을 확인해보세요.'
              )
            }
          />
        </div>

        <div className="mt-[20px]">
          <div className="w-full">
            <ol className="flex flex-wrap justify-between">
              {Services_ARR.slice(0, 5).map((service) => (
                <li
                  key={service.id}
                  className="w-full lg:w-[calc(20%-1rem)] mobile:mb-2"
                >
                  <div
                    className={`shadow-md cursor-pointer transition-colors duration-300 ${
                      openId === service.id ? 'bg-[#FFCC00]' : 'text-black'
                    } table w-full max-h-[161px] h-[161px] rounded-[4px] border border-[#d8d8d86d] bg-[#ffffff2a]`}
                    onClick={() => toggleAnswer(service.id, 'first')}
                  >
                    <div className="flex flex-col pt-[16px] pb-[32px] px-[24px] text-[#141414]">
                      <span className="block h-[31px] text-[20px] Pretendard-Bold">
                        {service.no}.
                      </span>
                      <span className="pt-[9px] overflow-hidden w-full Pretendard-Bold text-ellipsis text-wrap text-base">
                        {service.title}
                      </span>
                    </div>
                  </div>
                  {isMobile && openId === service.id && activeSection === 'first' && (
                    <div className="w-full h-[400px] overflow-y-scroll overflow-hidden mt-2 border-t-[#e8e8e8] shadow-lg bg-[#f6f6f6]">
                      <div className="flex justify-between items-center border-b border-b-[#ffffff72]">
                        <h2 className="text-xl mobile:text-base text-[#111] p-6 mobile:px-4 Pretendard-Bold">
                          {service.title}
                        </h2>
                        <IoCloseOutline
                          className="cursor-pointer text-2xl mr-6"
                          onClick={() => setOpenId(null)}
                        />
                      </div>
                      <p className="mt-4 px-6 mobile:px-4 mobile:text-xs Pretendard-Regular text-[#333]">
                        {service.answer}
                      </p>
                    </div>
                  )}
                </li>
              ))}
            </ol>

            {/* PC에서 기존 방식으로 답변 표시 */}
            {!isMobile && activeSection === 'first' && openId && (
              <div className="w-full h-[732px] mt-4 border-t-[#e8e8e8] shadow-lg bg-[#f6f6f6]">
                <div className="flex justify-between items-center border-b border-b-[#ffffff72]">
                  <h2 className="text-xl mobile:text-base text-[#111] p-6 mobile:px-4 Pretendard-Bold">
                    {
                      Services_ARR.find((service) => service.id === openId)
                        ?.title
                    }
                  </h2>
                  <IoCloseOutline
                    className="cursor-pointer text-2xl mr-6"
                    onClick={() => setOpenId(null)}
                  />
                </div>
                <p className="mt-4 px-6 mobile:px-4 mobile:text-xs Pretendard-Regular text-[#333]">
                  {
                    Services_ARR.find((service) => service.id === openId)
                      ?.answer
                  }
                </p>
              </div>
            )}
          </div>

          <div className="w-full mt-[50px] mobile:mt-[6px]">
            <ol className="flex flex-wrap justify-between">
              {Services_ARR.slice(5, 10).map((service) => (
                <li
                  key={service.id}
                  className="w-full lg:w-[calc(20%-1rem)] mobile:mb-2"
                >
                  <div
                    className={`shadow-md cursor-pointer transition-colors duration-300 ${
                      openId === service.id ? 'bg-[#FFCC00]' : 'text-[#111]'
                    } table w-full max-h-[161px] h-[161px] rounded-[4px] border border-[#d8d8d86d] bg-[#ffffff2a]`}
                    onClick={() => toggleAnswer(service.id, 'second')}
                  >
                    <div className="flex flex-col pt-[16px] pb-[32px] px-[24px] text-[#111]">
                      <span className="block h-[31px] text-[20px] Pretendard-Bold">
                        {service.no}.
                      </span>
                      <span className="pt-[9px] overflow-hidden w-full Pretendard-Bold text-ellipsis text-wrap text-base">
                        {service.title}
                      </span>
                    </div>
                  </div>
                  {isMobile && openId === service.id && activeSection === 'second' && (
                    <div className="w-full h-[400px] mt-2 border-t-[#e8e8e8] shadow-lg bg-[#f6f6f6]">
                      <div className="flex justify-between items-center border-b border-b-[#ffffff72]">
                        <h2 className="text-xl mobile:text-base text-[#111] p-6 mobile:px-4 Pretendard-Bold">
                          {service.title}
                        </h2>
                        <IoCloseOutline
                          className="cursor-pointer text-2xl text-[#111] mr-6"
                          onClick={() => setOpenId(null)}
                        />
                      </div>
                      <p className="mt-4 px-6 mobile:px-4 mobile:text-xs Pretendard-Regular text-[#333]">
                        {service.answer}
                      </p>
                    </div>
                  )}
                </li>
              ))}
            </ol>

            {/* PC에서 기존 방식으로 답변 표시 */}
            {!isMobile && activeSection === 'second' && openId && (
              <div className="w-full h-[732px] mt-4 border-t-[#e8e8e8] shadow-lg bg-[#f6f6f6]">
                <div className="flex justify-between items-center border-b border-b-[#ffffff72]">
                  <h2 className="text-xl mobile:text-base text-[#111] p-6 mobile:px-4 Pretendard-Bold">
                    {
                      Services_ARR.find((service) => service.id === openId)
                        ?.title
                    }
                  </h2>
                  <IoCloseOutline
                    className="cursor-pointer text-2xl text-[#111] mr-6"
                    onClick={() => setOpenId(null)}
                  />
                </div>
                <p className="mt-4 px-6 mobile:px-4 mobile:text-xs Pretendard-Regular text-[#333]">
                  {
                    Services_ARR.find((service) => service.id === openId)
                      ?.answer
                  }
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
